import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/site";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-20 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.55 }}
          className="lg:col-span-4"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-500 font-semibold mb-4">
            Before you ask
          </p>
          <h2
            data-testid="faq-heading"
            className="font-display font-bold uppercase tracking-tight text-slate-50 text-3xl sm:text-4xl lg:text-5xl leading-[0.95]"
          >
            Quick answers.
          </h2>
        </motion.div>

        <div className="lg:col-span-8 divide-y divide-line border-y border-line">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-accordion-item-${i + 1}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-question-${i + 1}`}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span
                    className={`font-display font-semibold uppercase tracking-wide text-lg sm:text-xl transition-colors ${
                      isOpen ? "text-orange-500" : "text-slate-100 group-hover:text-orange-400"
                    }`}
                  >
                    {f.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 text-orange-500 transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                      data-testid={`faq-answer-${i + 1}`}
                    >
                      <p className="pb-7 pr-10 text-slate-400 leading-relaxed text-[15px]">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
